var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { render } from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import PortalProvider from './components/portal_provider';
import SentryProvidedErrorBoundary from './components/ErrorBoundary';
import appConfig from './bootstrap/app_config';
import { isValidPageServiceEnv } from './bootstrap/utils';
import { getFallbackGraphqlUrl } from './bootstrap/constants';
import configureApollo from './bootstrap/configureApollo';
import configureSentry from './bootstrap/configureSentry';
import LayerManager from '@doordash/component-layer-manager';
import { ToastProvider } from '@doordash/component-toast';
import { Experience, parseExperience } from '@doordash/component-experience';
import reduxStore from './store';
import { Colors, PrismWebGlobalStyles } from '@doordash/design-language';
import { createGlobalStyle } from 'styled-components';
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    font-family: DD-TTNorms, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    margin: 0;\n    background-color: ", ";\n    min-height: 100vh;\n    overflow-x: hidden;\n    position: relative;\n    width: 100%;\n  }\n\n  a {\n    text-decoration: none;\n    color: ", ";\n    transition: color .1s ease\n  }\n\n  h1 {\n    font-weight: bold;\n  }\n"], ["\n  body {\n    font-family: DD-TTNorms, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    margin: 0;\n    background-color: ", ";\n    min-height: 100vh;\n    overflow-x: hidden;\n    position: relative;\n    width: 100%;\n  }\n\n  a {\n    text-decoration: none;\n    color: ", ";\n    transition: color .1s ease\n  }\n\n  h1 {\n    font-weight: bold;\n  }\n"
    /**
     * Page Service inject `initialState` into the template druing rendering process,
     * which invlove
     * 1. the Backend service paths (Restful API and GQL)
     * 2. (node) environment and experience (which should be doordash at all time)
     * 3. any other properties page service may inject
     */
])), Colors.SystemGrey5, Colors.BrandRedBase);
/**
 * This main function is being called by the templated rendered in Page Service
 * https://github.com/doordash/page-service/blob/6afdd2de84910abbbce4b51ced3dac2ddd69f20e/views/teams-portal/home.hbs#L55
 * @param {HTMLElement} container an HTML element React will mount as root of the Application
 * @param {InitialState} initialState a JSON object that inject by page service to configure the environment
 */
var main = function (container, initialState) {
    if (initialState.teamsServerUrl) {
        appConfig.SERVER_URL = initialState.teamsServerUrl;
    }
    var maybePageServiceEnv = isValidPageServiceEnv(initialState === null || initialState === void 0 ? void 0 : initialState.environment)
        ? initialState.environment
        : undefined;
    var experience = parseExperience(initialState.experience) || Experience.DoorDash;
    configureSentry({
        env: maybePageServiceEnv,
    });
    var graphqlUrl = initialState.graphqlUrl || getFallbackGraphqlUrl();
    var apolloClient = configureApollo(graphqlUrl, experience, {
        env: maybePageServiceEnv,
    }, {});
    render(React.createElement(SentryProvidedErrorBoundary, null,
        React.createElement(React.Fragment, null,
            React.createElement(PrismWebGlobalStyles, null),
            React.createElement(GlobalStyle, null),
            React.createElement(ApolloProvider, { client: apolloClient },
                React.createElement(LayerManager, null,
                    React.createElement(ToastProvider, { position: ToastProvider.Positions.TopCenter },
                        React.createElement(PortalProvider, { reduxStore: reduxStore })))))), container);
};
global.app = {
    default: main,
};
export default main;
var templateObject_1;
